/**
 * Add here any special route item
 * Label is the display name on the filter component
 * Value is the param sent to be with true -> { long_haul: true }
 */
export const specialRoutes = [
  {
    label: 'LH ES',
    value: 'long_haul',
  },
  {
    label: 'LH FR',
    value: 'long_haul_fr',
  },
  {
    label: 'INT',
    value: 'international',
  },
  {
    label: 'FTL',
    value: 'has_ftl_shipper_order',
  },
];

export const isSpecialRoute = (value) => {
  return specialRoutes.some((special) => special.value === value);
};

/**
 * @param {array} routes
 * @returns {object} { route: 'BCN->BCN,MAD->MAD', long_haul: true }
 */
const getRoutesFilter = (routes, filterEnabled = true) => {
  if (!routes || !routes.length || filteringByAll(routes)) return {};

  return (routes || []).reduce((acc, current) => {
    if (isSpecialRoute(current.value) && filterEnabled) return { ...acc, [current.value]: true };

    const valueWithTextFormatted = current.value.replace('-', '->');

    return {
      ...acc,
      route: [...(acc.route || []), valueWithTextFormatted],
    };
  }, {});
};

const filteringByAll = (routes) => {
  return (routes || []).find((route) => route.value === 'all');
};
export default getRoutesFilter;
